const lang = document.documentElement.getAttribute('lang') || 'de';

export default () => lang;
